import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccount from './account.reducer';

export const selectAccountState = createFeatureSelector<fromAccount.State>(
    fromAccount.accountsFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    fromAccount.adapter.getSelectors(selectAccountState);

export const selectContractARAccounts = createSelector(
    selectAccountState,
    x => x.ARContracts
);
